import { Building2, ChartLine, Map, Users, UserCheck } from 'lucide-react';
import { SectionHeader } from '../SectionHeader';
import { Reveal } from '../Reveal';

const AUDIENCE_ICONS = {
  'Business Owners': UserCheck,
  'Leadership Teams': Users,
  'Growing SMEs': ChartLine,
  'Multi-Site Organisations': Building2,
  'Consultants and Coaches': Map,
};

// Section 11 — who Compass is for (not every type of business).
export const CompassAudiences = ({ sp }) => (
  <section aria-labelledby="compass-audiences-heading" data-testid="compass-audiences" className="bg-mist py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        index="11"
        eyebrow="Who It's For"
        title="Built for businesses that want more control and consistency"
        testid="compass-audiences-header"
      />
      <ul className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {(sp.audiences || []).map((audience, i) => {
          const Icon = AUDIENCE_ICONS[audience.title] || Users;
          return (
            <Reveal key={audience.title} delay={(i % 3) * 0.06} className="h-full">
              <li className="flex h-full flex-col rounded-xl border border-slate-200 bg-white p-6" data-testid={`compass-audience-${i + 1}`}>
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-navy-900 text-gold-500">
                  <Icon className="h-5 w-5" aria-hidden="true" />
                </span>
                <h3 className="mt-4 text-base font-extrabold tracking-tight text-navy-900">{audience.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">{audience.text}</p>
              </li>
            </Reveal>
          );
        })}
        {sp.audiencesNote && (
          <Reveal delay={0.12} className="h-full">
            <li className="flex h-full items-center rounded-xl bg-navy-900 p-6" data-testid="compass-audiences-note">
              <p className="border-l-2 border-gold-500 pl-4 text-sm font-medium leading-relaxed text-slate-200">
                {sp.audiencesNote}
              </p>
            </li>
          </Reveal>
        )}
      </ul>
    </div>
  </section>
);
